import v5_Model from '@/models/v5/model';
var model = v5_Model.extend({});
model.type = 'invoice';
export default model;
